/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import { Text } from "UpduoLibrary";

import {
  skaleBlack,
  skaleWebBackgroundGray,
  skaleWhite,
} from "config/UpduoColors";
import SkillListing from "./SkillListing";

export default function SkillModuleDetail({
  skillList,
  skillModule,
  currentSkillId,
  _handleGetSkillDetail,
}) {
  return (
    <View>
      <View
        style={{
          backgroundColor: skaleWhite,
          borderWidth: 1,
          borderColor: skaleWebBackgroundGray,
          borderRadius: 12,
          flexGrow: 1,
          minHeight: 100,
          marginBottom: 24,
          padding: 32,
        }}
      >
        <View
          style={[
            {
              flex: 1,
              borderColor: skaleWebBackgroundGray,
              flexDirection: "row",
            },
          ]}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: skillList.length > 0 ? 32 : 0,
            }}
          >
            <Text
              style={{
                color: skaleBlack,
                fontSize: 24,
                maxWidth: window.innerWidth * 0.6 - 100,
              }}
            >
              {`${skillModule.order + 1}. ${skillModule.name}`}
            </Text>
          </View>
        </View>
        <View>
          {skillList.map((item, itemIndex) => (
            <SkillListing
              key={itemIndex}
              skillObject={item}
              currentSkillId={currentSkillId}
              _handleGetSkillDetail={_handleGetSkillDetail}
            />
          ))}
        </View>
      </View>
    </View>
  );
}
